import { Text, UnstyledButton } from "@mantine/core";
import { useDraggable, useDroppable } from "@dnd-kit/core";

import FieldChip from "../FieldChip/FieldChip";
import { useUpdateOrderByMutation } from "../../hooks/mutations";
import {
  DRAG_ORDER_BY,
  DROP_ORDER_BY_SLOT,
  orderBySlotId,
} from "../../dnd/kinds";

/**
 * OrderBy chip with a clickable ASC/DESC pill that toggles the sort
 * direction.
 */
export default function OrderByChip({
  ruleId,
  queryId,
  id,
  entityField,
  sortType,
  index,
  canEdit = false,
  onDelete,
}) {
  const { mutate: updateOrderBy } = useUpdateOrderByMutation({ ruleId });

  const {
    attributes,
    listeners,
    setNodeRef: setDragRef,
    isDragging,
  } = useDraggable({
    id: `order-by-drag::${id}`,
    data: {
      kind: DRAG_ORDER_BY,
      orderByItem: { id, entityField, sortType },
      index,
      queryId,
    },
    disabled: !canEdit,
  });

  const { setNodeRef: setDropRef } = useDroppable({
    id: orderBySlotId(id),
    data: { kind: DROP_ORDER_BY_SLOT, orderByItem: { id }, index, queryId },
    disabled: !canEdit,
  });

  const setRef = (node) => {
    setDragRef(node);
    setDropRef(node);
  };

  const handleToggleSort = () => {
    if (!canEdit) return;
    updateOrderBy({
      functionId: null,
      sortType: sortType === "DESC" ? "ASC" : "DESC",
      id,
    });
  };

  const sortPill = (
    <>
      <Text size="sm" c="dimmed" mx={4}>
        |
      </Text>
      {canEdit ? (
        <UnstyledButton onClick={handleToggleSort}>
          <Text size="sm" fw={500}>
            {sortType}
          </Text>
        </UnstyledButton>
      ) : (
        <Text size="sm" fw={500}>
          {sortType}
        </Text>
      )}
    </>
  );

  return (
    <FieldChip
      ruleId={ruleId}
      entityField={entityField}
      canEdit={canEdit}
      drag={canEdit}
      rightSlot={sortPill}
      onDelete={onDelete}
      showOptions={false}
      dragRef={setRef}
      dragHandleProps={{ ...attributes, ...listeners }}
      dragStyle={{ opacity: isDragging ? 0.4 : 1 }}
    />
  );
}
